export class ReasonInfo {
  constructor(public reason?: string) {}
}
